import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class GpsConnectivityService {

  constructor(
    private readonly http: HttpClient,
  ){
  }
  // Global bad H3 ids set for overlay styling/interactions
  public badIdsSet: Set<string> = new Set<string>();

getConnectivityData(startDate?: string, endDate?: string): Observable<{
  connectionStatusId: number;
  h3ZoneId: string;
  id: number;
  createdAtUtc: Date;
}[]> {
  const filters: any[] = [];
  
  if (startDate) {
    filters.push({ field: "StartDate", operator: "gte", value: startDate });
  }
  if (endDate) {
    filters.push({ field: "EndDate", operator: "lte", value: endDate });
  }

  const body = {
    orderByAsc: true,
    skip: 0,
    take: 10000000,
    sort: [],
    filter: { filters }
  };

  return this.http.post<{
    connectionStatusId: number;
    h3ZoneId: string;
    id: number;
    createdAtUtc: Date;
  }[]>(`${environment.mainapiUrl}/rides/gps-connectivities`, body);
}

  getServiceAreas(): Observable<{ id: number; name: string; state: string }[]> {
    return this.http.get<{ id: number; name: string; state: string }[]>(
      `${environment.mainapiUrl}/rides/service-area-dll`
    );
  }

getDeadzoneRideDetails(id: number): Observable<{
  rideId: number;
  driverId: number;
  durationTimeInSecond: number;
  affectedAtUtc: string;
  gpsConnectivityId: number;
  averageAccuracy: number;
  id: number;
  createdAtUtc: string | null;
  createdByName: string | null;
  isDeleted: boolean;
  createdByAccountId: number;
  driverName?: string;
}[]> {
  return this.http.get<{
    rideId: number;
    driverId: number;
    durationTimeInSecond: number;
    affectedAtUtc: string;
    gpsConnectivityId: number;
    id: number;
    averageAccuracy: number;
    createdAtUtc: string | null;
    createdByName: string | null;
    driverName?: string;
    isDeleted: boolean;
    createdByAccountId: number;
  }[]>(
    `${environment.mainapiUrl}/rides/gps-connectivity-details/${id}`
  );
}

}
